<template>
  <div class="container">
    <van-sticky>
      <div class="subtitle">
        <select-mu-wei v-if="show" ref="selectMuWei" />
      </div>
    </van-sticky>
    <div class="list-wrap">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="list.length !== 0">
        <div class="list-item" v-for="item in list" :key="item.id" @click="handleItem(item)">
          <img class="list-item_left" :src="item.tradeCoverPhoto" alt="" />
          <div class="list-item_right">
            <div>{{ item.tradeName }}</div>
            <div>￥ {{ item.price }}</div>
            <div>
              {{ item.productIntroduction }}
            </div>
          </div>
        </div>
      </van-list>
      <van-empty description="暂无收费项目" v-else />
    </div>
  </div>
</template>

<script>
import selectMuWei from '@/components/selectMuWei';
import { getList } from '@/api/good';
export default {
  name: 'index',
  components: { selectMuWei },
  data() {
    return {
      loading: false,
      finished: false,
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      show: false,
    };
  },
  activated() {
    this.show = false;
    if (!this.show) {
      setTimeout(() => {
        this.show = true;
      }, 0);
    }

    if (this.$route.meta.isBack) {
      this.init();
      this.$route.meta.isBack = false;
    }
  },
  methods: {
    test() {
      console.log(window.location.href);
    },
    init() {
      this.page.currentPage = 1;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    onLoad(page = this.page) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, this.query).then((res) => {
        const { rows } = res;
        if (this.page.currentPage == 1) {
          this.list = rows;
        } else {
          this.list = [...this.list, ...rows];
        }
        this.page.currentPage++;
        this.loading = false;
        if (this.list.length >= res.total) {
          this.finished = true;
        }
        console.log(this.list);
      });
    },
    handleItem(item) {
      this.$router.push({ name: 'goodsDetail', query: { id: item.id } });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.container {
  height: calc(100vh - 55px);
  overflow-y: auto;
  background: #ebecf0;
  padding: 0 8px;
  box-sizing: border-box;
}

.subtitle {
  position: relative;
  padding-left: 20px;
  line-height: 30px;
  background: #ebecf0;

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 22px;
    background: #67c23a;
    border-radius: 2px;
  }
}

.list-wrap {
  .list-item {
    padding: 12px 12px;
    height: 150px;
    box-sizing: border-box;
    display: flex;
    background: #fff;
    border-radius: 5px;
    margin-top: 15px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

    &:first-child {
      margin-top: 10px;
    }

    .list-item_left {
      width: 120px;
      height: 100%;
      padding-right: 10px;
    }

    .list-item_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      div:nth-child(1) {
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      div:nth-child(2) {
        height: 35px;
        line-height: 35px;
        font-size: 17px;
        color: #465cff;
        font-weight: 900;
      }

      div:nth-child(3) {
        font-size: 13px;
        color: #606266;
        line-height: 20px;
        word-wrap: break-word;
        /*强制换行*/
        // width: 100%;
        overflow: hidden; //超出文本隐藏
        text-overflow: ellipsis; //溢出显示省略号
        display: -webkit-box; //设置为弹性盒子
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; //只显示两行
      }
    }
  }
}

::v-deep input {
  height: 35px !important;
  font-size: 16px;
}
</style>
